import cx from 'classnames'
import { useContext } from 'react'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'

import Tabs from '~/components/Tabs'
import useTabsWithUrl from '~/utils/hooks/useTabsWithUrlPart'
import { experimentalEnableWorkflows } from '../utils/workcellStatus'
import WorkcellStatusContext from '../WorkcellStatusContext'
import cs from './protocols.scss'
import RoutineDefinitions from './RoutineDefinitions'
import WorkflowDefinitions from './WorkflowDefinitions'

const Protocols = ({ className }: { className?: string }) => {
  const match = useRouteMatch()
  const workcellStatus = useContext(WorkcellStatusContext)
  const workflowsEnabled = experimentalEnableWorkflows(workcellStatus)

  const TABS = [
    {
      key: 'routine-definitions',
      title: 'Routine Definitions',
    },
    ...(workflowsEnabled
      ? [{ key: 'workflow-definitions', title: 'Workflow Definitions' }]
      : []),
  ]

  const [tabs, selectedTabId, handleTabChange] = useTabsWithUrl(TABS)

  return (
    <div className={cx(className, cs.protocols)}>
      <Tabs
        tabs={tabs}
        selectedTabId={selectedTabId}
        className={cs.tabs}
        panelClassName={cs.tabPanel}
        onlyRenderWhenViewed
        empty
        nested
        onTabChange={handleTabChange}
      />
      <Switch>
        <Route
          exact
          path={match.path}
          render={() => <Redirect to={`${match.path}/routine-definitions`} />}
        />
        <Route
          path={`${match.path}/routine-definitions`}
          render={() => <RoutineDefinitions />}
        />
        <Route
          path={`${match.path}/workflow-definitions`}
          render={() => <WorkflowDefinitions />}
        />
      </Switch>
    </div>
  )
}

export default Protocols
